import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import { useEffect } from "react";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import Grid from "@mui/material/Grid";
import NoData from "../../assets/noAssets.png";
import { translate } from "../../utils/utils";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { requestUpdatingUserRole } from "../../redux/actions/usersManagementActionCreators";
import { useDispatch } from "react-redux";
import DeleteModal from "./DeleteModal";
import AccountConfirmed from "../../components/icons/AccountConfirmed";
import ConfirmationPending from "../../components/icons/ConfirmationPending";
import ControlPointOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

export default function SimpleAccordion({
  rows,
  head,
  handleSelectedUser,
  totalPages,
  page,
  handlePage,
  searchText,
  tabs,
  filter,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const storedUser = localStorage.getItem("user");

  const [data, setData] = useState([]);
  const [user, setUser] = useState({});

  useEffect(() => {
    setData(rows);
  }, [rows]);

  const handleRole = (value, id) => {
    dispatch(requestUpdatingUserRole(id, value));
  };
  return (
    <div>
      {data?.map((el) => (
        <>
          <div>
            <Accordion key={el?.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  backgroundColor: "#F3FBF9",
                  borderBottom: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  color: "#494949",

                  "& .MuiTypography-root": {
                    margin: 0,
                    fontSize: "12px",
                    fontWeight: 900,
                    fontFamily:
                      "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                    lineHeight: 1.3,
                    letterSpacing: "0.00938em",
                    "& .MuiPaper-root": { boxShadow: "none" },
                  },
                }}
              >
                <div>
                  <Typography>
                    UserName : {el?.first_name} {el?.last_name}{" "}
                  </Typography>
                  <br />
                  <Typography>role : {el?.role} </Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderBottom: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  color: "#121828",

                  "& .MuiTypography-root": {
                    margin: 0,
                    fontSize: "12px",
                    fontWeight: 800,
                    fontFamily:
                      "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                    lineHeight: 1.5,
                    letterSpacing: "0.00938em",
                    "& .MuiPaper-root": { boxShadow: "none" },
                  },
                }}
              >
                <Typography>
                  <>
                    {/* <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 2px",
                      }}
                    >
                      <span style={{ color: "rgb(71 138 119)" }}>
                        {head[0]?.value?.substring(0, 13)}{" "}
                      </span>

                      <span>{el?.entreprise}</span>
                    </span>
                    <hr style={{ borderColor: "#B1B4BC5C" }} /> */}

                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 2px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span style={{ color: "rgb(71 138 119)" }}>
                        {head[1]?.value?.substring(0, 6)}{" "}
                      </span>

                      <span>{el?.email}</span>
                    </span>
                    <hr style={{ borderColor: "#B1B4BC5C" }} />
                    <span
                      style={{
                        padding: "5px 2px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ color: "rgb(71 138 119)" }}>role</span>
                        {/* <span>
                      {" "}
                      {el?.id !== JSON.parse(storedUser).public_id && (
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={el?.role}
                            label="role"
                            style={{ height: "45px" }}
                            onChange={(e) => handleRole(e.target.value, el?.id)}
                          >
                            <MenuItem value={"admin"}>{t("admin")}</MenuItem>
                            <MenuItem value={"user"}>{t("user")}</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </span> */}
                        <span>{t(el?.role)}</span>
                      </div>
                    </span>

                    {el?.role !== "admin" &&
                      el?.role !== "enterprise_admin" &&
                      el?.role !== "cytailor_admin" && (
                        <>
                          {" "}
                          <hr style={{ borderColor: "#B1B4BC5C" }} />
                          <span
                            style={{
                              padding: "5px 2px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                              }}
                            >
                              {el?.role !== "admin" &&
                                el?.role !== "enterprise_admin" &&
                                el?.role !== "cytailor_admin" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: 9,
                                      alignItems: "center",
                                    }}
                                  >
                                    {el?.status ? (
                                      <AccountConfirmed />
                                    ) : (
                                      <ConfirmationPending />
                                    )}
                                    <Typography
                                      variant="title9"
                                      sx={{
                                        color: el?.status
                                          ? "#1DB954"
                                          : "#D9822F",
                                      }}
                                    >
                                      {el?.status
                                        ? t("user_confirmed")
                                        : t("user_pending")}
                                    </Typography>
                                  </div>
                                )}
                            </div>
                          </span>{" "}
                        </>
                      )}

                    <hr style={{ borderColor: "#B1B4BC5C" }} />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "5px 2px",
                      }}
                    >
                      {" "}
                      {el?.role !== "enterprise_admin" &&
                        el?.role !== "cytailor_admin" && (
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{
                              height: "40px",
                              width: "50%",
                              m: "5px 5px",
                              display: "flex",
                              gap: "3px",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              handleSelectedUser(el);
                            }}
                          >
                            <ControlPointOutlinedIcon /> {t("Details")}
                          </Button>
                        )}
                      {JSON.parse(storedUser).role === "cytailor_admin" &&
                      el?.id !== JSON.parse(storedUser).public_id ? (
                        ((el?.role === "cytailor_admin" &&
                          JSON.parse(storedUser).super_admin) ||
                          el?.role !== "cytailor_admin") && (
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            sx={{
                              height: "40px",
                              width: "50%",
                              m: "5px 5px",
                              display: "flex",
                              gap: "3px",
                              alignItems: "center",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenDeleteModal(true);
                              setUser(el);
                            }}
                          >
                            <DeleteForeverOutlinedIcon />
                            {t("delete")}
                          </Button>
                        )
                      ) : el?.id !== JSON.parse(storedUser).public_id ? (
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          sx={{
                            height: "40px",
                            width: "50%",
                            m: "5px 5px",
                            display: "flex",
                            gap: "3px",
                            alignItems: "center",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenDeleteModal(true);
                            setUser(el);
                          }}
                        >
                          <DeleteForeverOutlinedIcon />
                          {t("delete")}
                        </Button>
                      ) : null}
                    </div>
                  </>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <br />
          </div>
          {rows.length === 0 && (
            <Grid container sx={{ textAlign: "center", mt: "100px" }}>
              <Grid item xs={12}>
                <Typography variant="title">No Data Found</Typography>
              </Grid>
              <Grid item xs={12}>
                <img src={NoData} alt="No Data" />
              </Grid>
            </Grid>
          )}
          <DeleteModal
            open={openDeleteModal}
            handleClose={() => setOpenDeleteModal(false)}
            user={user}
            buttonLabel={t("confirm")}
            page={page}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        </>
      ))}
      <Stack spacing={2} justifyContent="center" direction="row">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </div>
  );
}
